import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useGetItemCodeQuery } from '../../../store/api/itemCodeApi'
import { updatebidsRowsDetailsSlice } from '../../../store/slice/bidsSlice'
import { itemCodeColumns } from './columns'
import CommonGrid from '../../../components/DataGrid/CommonGrid'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Box from '@mui/material/Box'
import { head } from 'lodash'

const DialogWrapper = ({ isOpen, businessUnitId, rowParams, handleClose }) => {
  const dispatch = useDispatch()
  const { data: itemCodeData, isLoading: itemCodeLoading, error } = useGetItemCodeQuery(businessUnitId)
  const bidsRowsDetailsSlice = useSelector((state) => state.bidsSlice.bidsRowsDetailsSlice)
  const dynamicKey = bidsRowsDetailsSlice?.[0]?.bidDetailId ? 'bidDetailId' : bidsRowsDetailsSlice?.[0]?.rfqDetailId ? 'rfqDetailId' : 'id'

  const modRows = itemCodeData?.data?.map((item, index) => {
    return { ...item, id: index + 1 }
  })

  const handleUpdateData = (item) => {
    const rows = bidsRowsDetailsSlice.map((bidsItem) => {
      
      if (bidsItem[dynamicKey] === rowParams.id) {
        return {
          ...bidsItem,
          alternativeItemCode: head(item)?.item_Code ?? '',
          alternativeItemName: head(item)?.description ?? '',
        }
      }

      return bidsItem
    })

    dispatch(updatebidsRowsDetailsSlice(rows))
    handleClose()
  }

  return (
    <Dialog open={isOpen} keepMounted onClose={handleClose} fullWidth aria-describedby="alert-dialog-slide-description">
      <DialogTitle>{'Item code list'}</DialogTitle>
      <DialogContent>
        <Box sx={{ height: 400, width: '100%' }}>
          <CommonGrid
            columns={itemCodeColumns}
            data={{
              data: modRows,
            }}
            dynamicKey={'id'}
            isLoading={itemCodeLoading}
            error={error}
            setColumnVisibility={[]}
            columnVisibility={[]}
            handleUpdateData={handleUpdateData}
            height={'45vh'}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogWrapper
